import React from 'react';
import Grid from 'components/atoms/Grid';
import Field from 'components/molecules/Field';
import Form from 'components/molecules/Form';

function InsertsSection({ inserts, setInserts, form }) {
  const addCard = () => {
    setInserts(prev => [
      ...prev,
      {
        image: null,
        name: '',
        description: '',
        characteristicHeading: '',
        characteristicOption: '',
      },
    ]);
  };

  const removeCard = index => {
    setInserts(prev => prev.filter((_, i) => i !== index));
  };

  const updateImage = (insertIndex, file) => {
    setInserts(prev => {
      const updated = [...prev];
      updated[insertIndex].image = file;
      return updated;
    });
  };

  const updateName = (insertIndex, name) => {
    setInserts(prev => {
      const updated = [...prev];
      updated[insertIndex].name = name;
      return updated;
    });
  };

  const updateDescription = (insertIndex, description) => {
    setInserts(prev => {
      const updated = [...prev];
      updated[insertIndex].description = description;
      return updated;
    });
  };

  const updateCharacteristicHeading = (insertIndex, characteristicHeading) => {
    setInserts(prev => {
      const updated = [...prev];
      updated[insertIndex].characteristicHeading = characteristicHeading;
      return updated;
    });
    form.setFieldsValue({
      [`insert_characteristicHeading_${insertIndex + 1}`]: characteristicHeading,
    });
  };

  const updateCharacteristicOption = (insertIndex, characteristicOption) => {
    setInserts(prev => {
      const updated = [...prev];
      updated[insertIndex].characteristicOption = characteristicOption;
      return updated;
    });
  };

  return (
    <div className="inserts-holder">
      <div className="head">
        <span className="label">Inserts</span>
        <button className="add-more" type="button" onClick={addCard}>
          Add Insert <i className="material-icons-outlined">add</i>
        </button>
      </div>
      <Grid xs={1} lg={2} colGap={10} rowGap={20}>
        {inserts?.map((insert, insertIndex) => (
          <div className="card" key={insertIndex}>
            {inserts.length > 1 && (
              <button className="remove-btn" type="button" onClick={() => removeCard(insertIndex)}>
                <i className="material-icons-outlined">close</i>
              </button>
            )}
            <Form.Item
              name={`insert_image_${insertIndex + 1}`}
              type="chooseFile"
              small
              value={insert?.image}
              displayFile={insert?.image?.preview || insert?.image || null}
              onChange={file => updateImage(insertIndex, file)}
              rules={[{ required: false, message: `Select insert image` }]}>
              <Field />
            </Form.Item>
            <Form.Item
              label="Insert Name"
              name={`insert_name_${insertIndex + 1}`}
              type="text"
              sm
              value={insert?.name}
              onChange={e => updateName(insertIndex, e.target.value)}
              rules={[{ required: false, message: 'Enter insert name' }]}>
              <Field />
            </Form.Item>
            <Form.Item
              label="Insert Description"
              name={`insert_description_${insertIndex + 1}`}
              type="textarea"
              sm
              value={insert?.description}
              onChange={e => updateDescription(insertIndex, e.target.value)}
              rules={[{ required: false, message: 'Enter insert description' }]}>
              <Field />
            </Form.Item>
            <Form.Item
              label="Characteristics Heading"
              name={`insert_characteristicHeading_${insertIndex + 1}`}
              type="text"
              sm
              value={insert?.characteristicHeading}
              onChange={e => updateCharacteristicHeading(insertIndex, e.target.value)}
              rules={[{ required: false, message: 'Enter characteristics heading' }]}>
              <Field />
            </Form.Item>
            <Form.Item
              label="Characteristic Options"
              name={`characteristicOption_${insertIndex + 1}`}
              type="text"
              sm
              value={insert?.characteristicOption}
              onChange={e => updateCharacteristicOption(insertIndex, e.target.value)}
              rules={[{ required: false, message: 'Enter characteristic options' }]}>
              <Field />
            </Form.Item>
          </div>
        ))}
      </Grid>
    </div>
  );
}

export default InsertsSection;
